import { MessageSquare, TrendingUp, User, Play } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

type Tab = 'chat' | 'progress' | 'profile';

interface BottomNavProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  onGoWorkout?: () => void;
  hasWorkoutPlan?: boolean;
  isWorkoutActive?: boolean;
}

export function BottomNav({ activeTab, onTabChange, onGoWorkout, hasWorkoutPlan, isWorkoutActive }: BottomNavProps) {
  const tabs = [
    { id: 'chat' as Tab, icon: MessageSquare, label: 'Chat' },
    { id: 'progress' as Tab, icon: TrendingUp, label: 'Progress' },
    { id: 'profile' as Tab, icon: User, label: 'Profile' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[110]">
      {/* Go Workout Button - hidden when workout is active */}
      {hasWorkoutPlan && onGoWorkout && !isWorkoutActive && (
        <div className="px-4 pb-2 pt-4 bg-background">
          <Button 
            id="go-workout-button"
            onClick={onGoWorkout}
            className="h-12 w-full evolve-gradient font-display font-bold text-sm"
          >
            <Play className="w-5 h-5 mr-2" />
            Go Workout
          </Button>
        </div>
      )}
      
      {/* Navigation */}
      <nav className="bg-background">
        <div className="flex items-center justify-around h-16">
          {tabs.map(({ id, icon: Icon, label }) => (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={cn(
                "flex flex-col items-center justify-center gap-1 w-full h-full transition-all duration-300",
                activeTab === id 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <div className={cn(
                "relative p-2 rounded-xl transition-all duration-300",
                activeTab === id && "bg-primary/10"
              )}>
                <Icon className={cn(
                  "w-5 h-5 transition-transform duration-300",
                  activeTab === id && "scale-110"
                )} />
                {activeTab === id && (
                  <div className="absolute inset-0 rounded-xl evolve-glow opacity-50" />
                )}
              </div>
              <span className={cn(
                "text-[10px] font-medium uppercase tracking-wider transition-all",
                activeTab === id && "font-bold"
              )}>
                {label}
              </span>
            </button>
          ))}
        </div>
      </nav>
      {/* Despia safe area spacer - bottom */}
      <div className="safe-area-bottom bg-background" />
    </div>
  );
}
